<template>
  <TagInput
    v-bind="$props"
    ref="tagInput"
    :min="validatorOptions.tags.min"
    :max="validatorOptions.tags.max"
    :max-length="validatorOptions.tags.maxlength"
    :is-valid="valid"
    :name="name"
    :locale="language"
    :ai-effect="aiEffect"
    :source-entity-id="composition.id"
  />
</template>

<script>
import compositionValidator from 'commons/api/validators/composition/compositionValidator';
import TagInput from './TagInput.vue';
import compositionHelper from 'commons/composition/compositionHelper';

export default {
  name: 'CompositionTagInput',
  components: {
    TagInput,
  },
  props: {
    validate: {
      type: Boolean,
    },
    composition: {
      required: false,
    },
    language: {
      type: String,
    },
    aiEffect: {
      type: Boolean,
    },
  },
  data() {
    return {
      validatorOptions: compositionValidator.getDefaultOptions(),
    };
  },
  computed: {
    name() {
      return this.composition
        ? compositionHelper.getMetaDataPart({
            composition: this.composition,
            part: 'name',
            language: this.language,
          })?.value
        : null;
    },
    valid() {
      if (!this.composition || !this.validate) {
        return true;
      }
      return compositionValidator.validateTags(this.composition, {
        language: this.language,
      });
    },
    hasError() {
      return this.$refs.tagInput.hasError;
    },
  },
};
</script>
